import React from "react";

const votes = [
    {
        id: "10mio-schweiz",
        title: "Keine 10-Millionen-Schweiz",
        date: "14. Juni 2026",
    },
    {
        id: "zivildienstgesetz",
        title: "Zivildienstgesetz",
        date: "14. Juni 2026",
    },
];

const VoteCard = ({ v, showTopRule }) => (
    <article
        data-testid={`upcoming-vote-${v.id}`}
        className="w-full text-center"
        style={{
            padding: "64px 16px",
            borderTop: showTopRule
                ? "1px solid var(--plenum-line-2)"
                : "none",
        }}
    >
        <h3
            className="font-medium text-[28px] sm:text-[40px] lg:text-[48px] leading-[1.05] tracking-[-0.035em]"
            style={{ color: "var(--plenum-text)" }}
        >
            {v.title}
        </h3>
        <p
            className="mt-5 sm:mt-6 text-[12px] sm:text-[13px] uppercase tracking-[0.32em]"
            style={{
                color: "var(--plenum-accent-2)",
                fontFamily: "var(--font-mono)",
            }}
        >
            {v.date}
        </p>
    </article>
);

export const UpcomingVotes = () => {
    return (
        <section
            id="upcoming-votes"
            className="relative w-full"
            data-testid="upcoming-votes-section"
        >
            <div className="max-w-[1180px] mx-auto px-6 sm:px-10 lg:px-14 py-24 sm:py-32">
                <div
                    className="max-w-[760px] mx-auto"
                    style={{
                        borderTop: "1px solid var(--plenum-line-2)",
                        borderBottom: "1px solid var(--plenum-line-2)",
                    }}
                >
                    {votes.map((v, i) => (
                        <VoteCard key={v.id} v={v} showTopRule={i > 0} />
                    ))}
                </div>
            </div>
        </section>
    );
};

export default UpcomingVotes;
